import React, { ChangeEvent } from 'react';
import { observer } from 'mobx-react';
import { observable, action, computed } from 'mobx';
import intl from 'react-intl-universal';
import './Search.scss';
import { fixIosFocusProblem } from '../../utils/dom';
import { getPendantColor } from '../../utils/color';
import chroma from 'chroma-js';

interface ISearchRow {
  search?: (input: string) => void;
  placeholder?: string;
  mainColor: string;
  h1Color: string;
  h2Color: string;
}
@observer
class SearchRow extends React.Component<ISearchRow> {
  @observable input = '';
  @action changeInput = (e: ChangeEvent<HTMLInputElement>) => {
    this.input = e.target.value;
  };
  @computed get active() {
    return !!this.input;
  }
  search = () => {
    const { input } = this;
    this.props.search && this.props.search(input);
  };

  @action clear = (dispatchChange: boolean) => {
    this.input = '';
    if (dispatchChange) {
      this.props.search && this.props.search(this.input);
    }
  };

  render() {
    const [backgroundColor, foreColor] = getPendantColor(this.props.mainColor);
    return (
      <div className="searchrow">
        <input
          placeholder={this.props.placeholder}
          value={this.input}
          onChange={this.changeInput}
          onBlur={e => fixIosFocusProblem(e.target)}
          style={{
            // backgroundColor: chroma(backgroundColor).alpha(0.3).css(),
            backgroundColor: 'transparent',
            borderColor: chroma(this.props.h1Color)
              .alpha(0.3)
              .css(),
            color: this.props.h1Color
          }}
        />
        <button
          className={'search-btn ' + (this.active ? 'active' : '')}
          onClick={this.search}
          style={{ backgroundColor: this.props.mainColor, color: foreColor }}
        >
          {intl.get('Search')}
        </button>
      </div>
    );
  }
}

export default SearchRow;
